import { Button, Grid2, IconButton, Stack, Typography } from "@mui/material";
import { IconBell, IconPlus, IconTrash } from "@tabler/icons-react";
import StudentGraduationRegister from "./StudentGraduationRegister";
import { useState } from "react";
import { toast } from "react-toastify";
import {
  getGraduationsStudent,
  notificationGraduationsStudent,
  putGraduationsStudent,
  removeGraduationsStudent,
} from "../services/students";
import { useMutation, useQuery } from "@tanstack/react-query";
import Loading from "./Loading";
import { isColorLight } from "../helpers/format";
import StudentGraduationDelete from "./StudentGraduationDelete";
import StudentGraduationNotificate from "./StudentGraduationNotificate";
import StudentGraduationConfirm from "./StudentGraduationConfirm";
import moment from "moment";

const GraduationList = ({
  studentId,
  refetch,
}: {
  studentId: number;
  refetch: () => void;
}) => {
  const [open, setOpen] = useState<any>({ open: false, data: null, type: "" });
  const [openDelete, setOpenDelete] = useState<any>({
    open: false,
    data: null,
  });

  const {
    data: fights,
    isLoading: isLoadingFights,
    isFetching: isFetchingFights,
    refetch: refetchFights,
  }: {
    data: {
      id: string;
      name: string;
      description?: string;
      graduations: {
        belt: string;
        color: string;
        fightsId: string;
        id: string;
        minClass: number;
        minMonthTime: number;
        status: true;
      }[];
      status: boolean;
      studentGraduations: {
        belt: string;
        color: string;
        fightsId: string;
        id: string;
        frequency: number;
        monthsInGradution: number;
        status: boolean;
        graduationDate: Date;
      }[];
      nextGraduantion: {
        belt: string;
        color: string;
        fightsId: string;
        id: string;
        minClass: number;
        minMonthTime: number;
        month: number;
        order: number;
        status: boolean;
        studentGraduationId: string;
        frequency: number;
      };
    }[];
    isLoading: boolean;
    isFetching: boolean;
    refetch: () => void;
  } = useQuery({
    queryFn: async () => await getGraduationsStudent({ studentId }),
    queryKey: ["getGraduationsStudent" + studentId],
    initialData: [],
  });

  const { mutate, isPending } = useMutation({
    mutationFn: putGraduationsStudent,
    onSuccess: () => {
      setOpen({ open: false, data: null, type: "" });
      refetch();
      refetchFights();
      toast.success("Graduação cadastrada com sucesso.");
    },

    onError: (e: { response: { data: { message: string } } }) => {
      toast.error(String(e?.response?.data?.message) || "Erro!");
    },
  });

  const { mutate: mutateDelete, isPending: isPendingDelete } = useMutation({
    mutationFn: removeGraduationsStudent,
    onSuccess: () => {
      refetch();
      refetchFights();
      toast.success("Graduação removida com sucesso.");
    },

    onError: (e: { response: { data: { message: string } } }) => {
      toast.error(String(e?.response?.data?.message) || "Erro!");
    },
  });

  const { mutate: mutateNotificate, isPending: isPendingNotificate } =
    useMutation({
      mutationFn: notificationGraduationsStudent,
      onSuccess: () => {
        refetch();
        refetchFights();
        toast.success("Notificação enviada com sucesso.");
      },

      onError: (e: { response: { data: { message: string } } }) => {
        toast.error(String(e?.response?.data?.message) || "Erro!");
      },
    });

  return (
    <Stack spacing={2}>
      <Loading
        loading={
          isPending ||
          isPendingDelete ||
          isPendingNotificate ||
          isLoadingFights ||
          isFetchingFights
        }
      />
      <Stack
        sx={{
          flexDirection: "row",
          padding: 2,
          borderRadius: 4,
          alignItems: "center",
          backgroundColor: "secondary.main",
          gap: 1,
          cursor: "pointer",
          "&:hover": {
            scale: 0.875,
          },
        }}
        onClick={() => setOpen((i: any) => ({ ...i, open: true, type: "ADD" }))}
      >
        <IconPlus />
        <Typography variant="h6" fontWeight={700}>
          Adicionar graduação
        </Typography>
      </Stack>
      <Grid2 container spacing={2}>
        {fights
          ?.filter((f) => f?.studentGraduations?.length > 0)
          ?.map((v) => (
            <>
              <Grid2 size={12}>
                <Typography variant="body1" fontWeight={700}>
                  {v?.name}
                </Typography>
              </Grid2>
              {v?.studentGraduations?.map((g) => {
                const color = isColorLight(g?.color) ? "#000" : "#fff";
                return (
                  <Grid2 key={g?.id} size={12}>
                    <Stack
                      sx={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        padding: 2,
                        borderRadius: 3,
                        backgroundColor: g.color ? g.color : "secondary.dark",
                        color: color,
                      }}
                    >
                      <Stack spacing={0.5}>
                        <Typography variant="body1" fontWeight={700}>
                          {g.belt}
                        </Typography>
                        {Boolean(g.frequency) && (
                          <Typography variant="body1" fontSize={12}>
                            Frequência: {g?.frequency || 0}
                          </Typography>
                        )}
                        {Boolean(g.monthsInGradution) && (
                          <Typography variant="body1" fontSize={12}>
                            Tempo (mês): {g?.monthsInGradution || 0}
                          </Typography>
                        )}
                        {Boolean(g.graduationDate) && (
                          <Typography variant="body1" fontSize={12}>
                            Data da graduação:{" "}
                            {moment(g?.graduationDate).format("DD/MM/YYYY")}
                          </Typography>
                        )}
                      </Stack>
                      <Stack
                        sx={{
                          flexDirection: "row",
                          gap: 1,
                          alignItems: "center",
                        }}
                      >
                        <IconButton
                          sx={{ backgroundColor: "secondary.dark" }}
                          onClick={() =>
                            setOpen({
                              open: true,
                              data: g,
                              type: "NOTIFICATION",
                            })
                          }
                        >
                          <IconBell size={18} />
                        </IconButton>
                        <IconButton
                          sx={{ backgroundColor: "secondary.dark" }}
                          onClick={() => setOpenDelete({ open: true, data: g })}
                        >
                          <IconTrash size={18} />
                        </IconButton>
                      </Stack>
                    </Stack>
                  </Grid2>
                );
              })}
              {v?.nextGraduantion && (
                <>
                  <Grid2 size={12}>
                    <Typography variant="body1" fontWeight={700}>
                      Proxima graduação
                    </Typography>
                  </Grid2>

                  <Grid2 size={12}>
                    <Stack
                      sx={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        padding: 2,
                        borderRadius: 3,
                        backgroundColor: v?.nextGraduantion?.color
                          ? v?.nextGraduantion?.color
                          : "secondary.dark",
                        color: isColorLight(v?.nextGraduantion?.color)
                          ? "#000"
                          : "#fff",
                      }}
                    >
                      <Stack spacing={0.5}>
                        <Typography variant="body1" fontWeight={700}>
                          {v?.nextGraduantion?.belt}
                        </Typography>
                        <Typography variant="body1" fontSize={12}>
                          Aulas:{" "}
                          {` ${v?.nextGraduantion?.frequency} / ${v?.nextGraduantion?.minClass}`}
                        </Typography>
                        <Typography variant="body1" fontSize={12}>
                          Tempo (mês):{" "}
                          {` ${v?.nextGraduantion?.month || 0} / ${
                            v?.nextGraduantion?.minMonthTime
                          }`}
                        </Typography>
                      </Stack>
                      <Button
                        variant="contained"
                        size="small"
                        onClick={() =>
                          setOpen({
                            open: true,
                            data: v?.nextGraduantion,
                            type: "GRADUATE",
                          })
                        }
                      >
                        Graduar aluno
                      </Button>
                    </Stack>
                  </Grid2>
                </>
              )}
            </>
          ))}
      </Grid2>
      {open.type === "ADD" && (
        <StudentGraduationRegister
          open={open.open}
          onClose={() => setOpen({ open: false, data: null, type: "" })}
          handleMutate={(v) => {
            setOpen({ open: false, data: null });
            mutate({ ...v, studentId });
          }}
          fights={fights}
        />
      )}

      {open.type === "NOTIFICATION" && (
        <StudentGraduationNotificate
          open={open.open}
          onClose={() => setOpen({ open: false, data: null, type: "" })}
          onConfirm={() => {
            mutateNotificate({
              graduationId: open.data.id,
              studentId,
            });
            setOpen({ open: false, data: null });
          }}
        />
      )}

      {open.type === "GRADUATE" && (
        <StudentGraduationConfirm
          open={open.open}
          onClose={() => setOpen({ open: false, data: null, type: "" })}
          onConfirm={() => {
            mutate({
              fightId: open.data.fightsId,
              graduationId: open.data.id,
              studentId,
              lastGraduation: {
                studentGraduationId: open.data.studentGraduationId,
                monthsInGradution: open.data.month,
                frequency: open.data.frequency,
              },
              frequency: open.data.frequency,
            });
            setOpen({ open: false, data: null });
          }}
        />
      )}

      <StudentGraduationDelete
        open={openDelete.open}
        onClose={() => setOpenDelete({ open: false, data: null, type: "" })}
        onConfirm={() => {
          mutateDelete({ graduationId: openDelete.data?.id, studentId });
          setOpenDelete({ open: false, data: null });
        }}
      />
    </Stack>
  );
};

export default GraduationList;
